import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestResponse } from '../intefaces/requestResponse';
import { BaseService } from './base.service';
import { BrowserStorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ArrangerService extends BaseService {

  
  constructor(protected http: HttpClient, private browserStorageService: BrowserStorageService) {
    super();
  }

  public getProfit(data) {
    return this.http.post<RequestResponse>(this.getUrl('getProfit'), data);
  }

}
